export default "../fonts/akzidgrtskpromed-webfont.50f3c80c2883ea85343c5d31c0a219f8.woff2";